import React, { useContext, useMemo } from 'react';
import { AppAgentContext } from '../../../context/ContextProvider';
import ModalComponent, { DialogFormProps } from './index';
import { ModalType } from '../../../types/Modal';
import { ConfirmationModal, ConfirmationProps } from './ConfirmationModal';
import { HashRouter } from 'react-router-dom';
import { DocumentResultsModal } from './DocumentResultsModal';
import { AssetsAgentModal } from './AssetsAgentModal';
import { DocumentRetrieversModal } from './DocumentRetrieversModal';

export type ModalsTypes<T> = DialogFormProps<T> | ConfirmationProps;

export default function ModalWrapperComponent() {
    const { state: { modal } } = useContext(AppAgentContext);

    const modals = useMemo(() => {
        return Object.entries(modal).reduce((acc: any[], [key, value]) => {
            if (value) acc.push({ type: key as ModalType, data: value as any });
            return acc;
        }, []);
    }, [modal]);

    return (
        <HashRouter>
            {modals.map(({ type, data }) => {
                switch (type) {
                    case ModalType.DYNAMIC:
                        return <ModalComponent key={type} {...data} />;
                    case ModalType.CONFIRMATION:
                        return <ConfirmationModal key={type} {...data} />;
                    case ModalType.DOCUMENT_RESULTS:
                        return <DocumentResultsModal key={type} {...data} />;
                    case ModalType.ASSETS_AGENT:
                        return <AssetsAgentModal key={type} {...data} />;
                    case ModalType.DOCUMENT_RETRIEVERS:
                        return <DocumentRetrieversModal key={type} {...data} />;
                    default:
                        return null;
                }
            })}
        </HashRouter>
    );
}